const uniqueIdCache = new WeakMap();
export const NOT_AN_OBJECT = 0;
let nextId = 1; // reserving 0 for values that can't be keys in a WeakMap
function generateUniqueId() {
  return nextId++;
}

/**
 * Generates and caches (in a memory-safe manner) a unique ID for a given object
 * by its reference.  Useful for factoring the uniqueness of an object into a
 * memoization key string or react key.
 *
 * Supports Objects, Arrays, Functions, and Regexes, but not null, undefined, or
 * values like strings, numbers, and booleans.
 */
export default function uniqueIdForObject(object) {
  let id = uniqueIdCache.get(object);
  if (id === undefined) {
    id = generateUniqueId();
    try {
      uniqueIdCache.set(object, id);
    } catch (e) {
      return NOT_AN_OBJECT;
    }
  }
  return id;
}